import styled from "styled-components";

import { Default } from "Types";
import { search } from "images";

import AtomLabel from "Components/Atoms/Label";
import AtomTextField from "Components/Atoms/TextField";

export type PropsType = any;

const Wrap = styled.label<Default>`
   display: flex;
   flex-direction: column;
   row-gap: 10px;
   margin-top: 25px;
   ${({ css }) => css}
`;

const FieldWrap = styled.div`
   position: relative;
`;

const TextField = styled(AtomTextField)`
   width: 100%;
`;
const Button = styled.button`
   position: absolute;
   right: 0;
   top: 0;
   padding: 11.5px;
   border: none;
   outline: none;
   background-color: transparent;
   cursor: pointer;
   & > img {
      display: block;
      width: 17px;
      height: 17px;
   }
`;

function Text(props: PropsType) {
   return (
      <FieldWrap>
         <TextField onKeyDown={props.onKeyDown} onChange={props.onChange} value={props.value} placeholder={props.placeholder}></TextField>
         <Button onClick={props.onClick}>
            <img src={search} alt="search" />
         </Button>
      </FieldWrap>
   );
}

export default function MoleculeFormText(props: PropsType) {
   return (
      <Wrap {...props}>
         <AtomLabel></AtomLabel>
         <Text></Text>
      </Wrap>
   );
}

MoleculeFormText.Wrap = Wrap;
MoleculeFormText.Label = AtomLabel;
MoleculeFormText.Text = Text;
